<p-dialog
  header="Информация!"
  class="ui-dialog-component"
  [class.max-width-window]="isMaximizableDisplay"
  [ngClass]="'error-dialog-window'"
  [styleClass]="'m2d-dialog'"
  [(visible)]="showM2DModal"
  id="m2dModal"
  [responsive]="false"
  [minY]="70"
  [modal]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  (onHide)="onClose()"
  (onMaximize)="onMaximize($event)"
>
  <div class="common-dialog__content">
    <div>
      Размещая настоящее предварительное предложение, в соответствии с п. 2 ч. 12 ст. 93 Закона
      №44-ФЗ участник закупки выражает согласие на направление оператором электронной площадки
      заказчикам предложений о поставке товаров, соответствующих требованиям, установленным в
      извещениях об осуществлении закупок в соответствии с пп. "в" п. 3 ч. 12 ст. 93 Закона №44-ФЗ.
    </div>
    <div>
      При этом <b>ответственность за достоверность информации и документов, </b> содержащихся в
      предварительном предложении, за соответствие указанных информации и документов требованиям,
      установленным законодательством Российской Федерации, <b>несет участник закупки.</b>
    </div>
    <br />
    <div *ngIf="powerOfAttorneyInfo">
      <span><b>Сведения о машиночитаемой доверенности</b></span> <br />
      <span>Номер: {{ powerOfAttorneyInfo.docNumber }}</span
      ><br />
      <span
        >Дата выдачи:
        {{
          powerOfAttorneyInfo.issueDate
            ? (powerOfAttorneyInfo.issueDate | utcToMoscow | dateTime: { dateFormat: 'dd.MM.yyyy' })
            : ''
        }}</span
      ><br />
      <span
        >Полномочия пользователя:
        {{
          powerOfAttorneyInfo.authorities ? powerOfAttorneyInfo.authorities.join('; ') : ''
        }}</span
      ><br />
      <a (click)="downloadFile(powerOfAttorneyInfo.powerOfAttorneyEisId)" class="file-download-link"
        >Скачать МЧД&nbsp;</a
      >
    </div>
  </div>
  <p-footer>
    <div class="common-dialog__footer">
      <button
        class="btn btn__white-with-shadow"
        id="acceptBtn"
        type="button"
        (click)="onAcceptM2DModal()"
      >
        Продолжить
      </button>
      <button
        class="btn btn__white-with-shadow close-btn"
        id="closeWindow"
        type="button"
        (click)="onClose()"
      >
        Закрыть
      </button>
    </div>
  </p-footer>
</p-dialog>
